export const LOADING = 'wedding/LOADING';
export const SET_WEDDING = 'wedding/SET_WEDDING';
// export const ASSIGN_WEDDING_TOKEN = 'wedding/ASSIGN_WEDDING_TOKEN';
export const UPDATE_WEDDING_SUCCESS = 'wedding/UPDATE_WEDDING_SUCCESS';